// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"512":"d63f5cae","592":"aa118441","709":"b3c6f280","744":"3c732a2b"}[chunkId] + ".chunk.js";
};